import React from "react"
import withQuery from "with-query"
import styled from "@emotion/styled"
import type { ScoreReport as ScoreReportType } from "../../state_types"
import AvatarPreview from "../AvatarPreview"
import ScoreReport from "./ScoreReport"

const TitleParts = styled.div({
  display: "flex",
  flexDirection: "row",
  marginBottom: 4
})

const AvatarContainer = styled.div({
  flexShrink: 0
})

const UserName = styled.div({
  fontSize: "12px",
  lineHeight: "16px",
  color: "black",
  marginLeft: 8
})

const titleGenerator = ({ user }) => (
  <TitleParts>
    <AvatarContainer>
      <AvatarPreview size={30} value={user.avatar} name={user.name} />
    </AvatarContainer>
    <UserName>{user.name}</UserName>
  </TitleParts>
)

type SectionReportParams = ScoreReportType & {
  title: string
  parentTitle: string
  reportId: string
  subReportId: string
  reportUrl: string
  returnTo?: {
    to: string
    name: string
  }
  filters?
}

const SectionReport = (params: SectionReportParams) => {
  const { reportUrl, title, parentTitle, filters } = params

  const linkToGenerator = (row) =>
    withQuery(`/ripple/${row.rippleUuid}/heatmap`, {
      ...filters,
      returnTo: {
        name: `Report: ${parentTitle} - ${title}`,
        url: reportUrl
      }
    })

  return (
    <ScoreReport
      {...params}
      customTitle={titleGenerator}
      linkTo={linkToGenerator}
      filtersReadonly
    />
  )
}

export default SectionReport
